import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@clouway/ui'

import { useVendors } from '../hooks'

export function VendorSelector({ value, onChange }: { value?: string; onChange: (value: string) => void }) {
  const { t } = useTranslation('feature')
  const { data: vendors = [] } = useVendors()

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger aria-label={t('trackingObjects.activationForm.vendor')}>
        <SelectValue placeholder={t('vendor.select.placeholder')} />
      </SelectTrigger>
      <SelectContent>
        {vendors.map((vendor) => (
          <SelectItem key={vendor.id} value={vendor.id}>
            {vendor.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
